import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Image, Row, Col } from 'react-bootstrap';
import TourPlace from "./TourPlace";
import Testimonials from "./Testimonials";
import Achievements from './Achievements';
import '../Styles/home.css';

export default class Home extends Component {
  render() {
    return (
      <div>
        {/* Hero Section */}
        <div className="hero-section">
  <Grid>
    <div className="hero-content">

      {/* Brand Badge */}
      <div className="hero-badge">
        <span>WE NEST YOUR HOLIDAYS</span>
      </div>

      {/* Main Heading */}
      <h1 className="hero-main-title">
        KAIRALY HOTELS & HOLIDAYS
      </h1>

      {/* Accreditation */}
      <div className="accreditation-badge1">
        <div className="accreditation-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 3L14.5 8.5L20.5 9.2L16 13.3L17.2 19.2L12 16.2L6.8 19.2L8 13.3L3.5 9.2L9.5 8.5L12 3Z"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div className="accreditation-text">
          <span className="accreditation-label">
            KERALA GOVERNMENT ACCREDITED
          </span>
          <span className="accreditation-subtext">
            Officially Accredited Tour Operator
          </span>
        </div>
      </div>

      {/* Tagline */}
      <div className="hero-tagline">
        <span className="tagline-think">Think Kerala</span>
        <span className="tagline-divider">•</span>
        <span className="tagline-choose">Choose Kairaly</span>
      </div>

      {/* Description */}
      <div className="hero-description">
        <p>
          Experience the true essence of God's Own Country with our premium
          travel services, luxurious accommodations, and curated holiday
          experiences that create memories for a lifetime.
        </p>
      </div>

      {/* CTA */}
      <Link to="/services">
        <button className="explore-more-btn">
          <span className="btn-text">Explore More</span>

          <svg
            className="btn-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5 12H19M19 12L12 5M19 12L12 19"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </Link>

    </div>
  </Grid>
</div>                
        
        {/* Enhanced About Section */}
        <div className="about-agency-section">
          <div className="section-pattern"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="about-content-left">
                <div className="about-badge">
                  <span>Why Choose Us</span>
                </div>
                <h2 className="about-main-title">
                  The best agency you can choose
                </h2>
                <div className="about-description">
                  <p>
                    We are a trusted local travel agency based in South India, specializing in delivering 
                    authentic and reliable travel experiences. Our strong local presence enables us to 
                    provide immediate on-ground support, ensuring that any concerns or requirements of 
                    our guests are addressed promptly and efficiently.
                  </p>
                  <p>
                    We offer comprehensive 24/7 travel services, including travel planning, customized 
                    itinerary design, hotel bookings, houseboat reservations, ticketing, and transportation 
                    arrangements. Additionally, we curate personalized holiday packages tailored to meet 
                    each client's preferences, needs, and budget—ensuring a seamless and memorable travel 
                    experience.
                  </p>
                </div>
                
                <div className="about-features">
                  <div className="feature">
                    <div className="feature-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z" fill="currentColor"/>
                      </svg>
                    </div>
                    <div>
                      <h4>Local Expertise</h4>
                      <p>Deep knowledge of South India's hidden gems</p>
                    </div>
                  </div>
                  <div className="feature">
                    <div className="feature-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 8V12L15 15M21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12Z" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                    </div>
                    <div>
                      <h4>24/7 Support</h4>
                      <p>Round-the-clock assistance for your peace of mind</p>
                    </div>
                  </div>
                  <div className="feature">
                    <div className="feature-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M3 9L12 3L21 9L12 15L3 9Z" stroke="currentColor" strokeWidth="2"/>
                        <path d="M12 15V21M9 18H15" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                    </div>
                    <div>
                      <h4>Customized Packages</h4>
                      <p>Tailored itineraries to match your preferences</p>
                    </div>
                  </div>
                </div>
                
                <Link to="/services" className="about-learn-more">
                  <span>Discover Our Services</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </Link>
              </Col>
              
              <Col xs={12} md={6} className="about-content-right">
                <div className="stats-grid">
                  <div className="stat-card">
                    <div className="stat-number">10+</div>
                    <div className="stat-label">Years of Excellence</div>
                    <div className="stat-icon">
                      <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
                      </svg>
                    </div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-number">5000+</div>
                    <div className="stat-label">Happy Travelers</div>
                    <div className="stat-icon">
                      <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" stroke="currentColor" strokeWidth="2"/>
                        <path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M9 9H9.01M15 9H15.01" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                    </div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-number">1000+</div>
                    <div className="stat-label">Hotel Partners</div>
                    <div className="stat-icon">
                      <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                        <path d="M3 9L12 3L21 9L12 15L3 9Z" stroke="currentColor" strokeWidth="2"/>
                        <path d="M12 15V21M9 18H15" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                    </div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-number">50+</div>
                    <div className="stat-label">Destinations</div>
                    <div className="stat-icon">
                      <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2C8.13 2 5 5.13 5 9C5 13.17 12 22 12 22C12 22 19 13.17 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="currentColor"/>
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div className="trust-badge">
                  <div className="trust-icon">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12L11 14L15 10M21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12Z" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                  <div>
                    <h4>100% Trusted & Verified</h4>
                    <p>Over a decade of delivering exceptional travel experiences</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        <Achievements />
        
        <TourPlace/>

        {/* NEW: Responsible Tourism Section */}
        <div className="responsible-tourism-home-section">
          <div className="rt-home-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="rt-home-content">
                <div className="rt-home-badge">
                  <span>Sustainable Travel</span>
                </div>
                <h2 className="rt-home-title">
                  Kerala Responsible Tourism
                </h2>
                <p className="rt-home-description">
                  At Kairaly Hotels & Holidays, we are committed to responsible tourism practices 
                  that benefit local communities, protect the environment, and preserve Kerala's 
                  rich cultural heritage.
                </p>
                <div className="rt-home-features">
                  <div className="rt-feature">
                    <i className="fas fa-users"></i>
                    <span>Community Empowerment</span>
                  </div>
                  <div className="rt-feature">
                    <i className="fas fa-leaf"></i>
                    <span>Eco-friendly Practices</span>
                  </div>
                  <div className="rt-feature">
                    <i className="fas fa-hand-holding-heart"></i>
                    <span>Cultural Preservation</span>
                  </div>
                  <div className="rt-feature">
                    <i className="fas fa-tree"></i>
                    <span>Wildlife Conservation</span>
                  </div>
                </div>
                <Link to="/responsible-tourism" className="rt-home-button">
                  <span>Know More About Our RT Initiatives</span>
                  <i className="fas fa-arrow-right"></i>
                </Link>
              </Col>
              <Col xs={12} md={6} className="rt-home-image">
                <div className="rt-image-wrapper">
                  <img src="/assets/img/responsible-tourism-banner.jpg" alt="Responsible Tourism" />
                  <div className="rt-image-stats">
                    <div className="stat">
                      <span className="number">85%</span>
                      <span className="label">Local Employment</span>
                    </div>
                    <div className="stat">
                      <span className="number">40%</span>
                      <span className="label">Plastic Reduction</span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
        
        <div className="content-wrapper">    
          <Image src="/assets/img/kairaly_certificates1.jpeg" fluid />
        </div>               
        
        <Testimonials />
        
        <div className="banner text-center">
          <h2>Our Successful Groups</h2>
          <p>Group From Nazik, Maharashtra</p>          
          <div className="content-wrapper">    
            <Image src="/assets/img/group1.jpg" style={{ width: '50%', display: 'block', margin: '0 auto' }} fluid />
          </div>
          <p>Temple tour -- Kanyakumari - Rameswaram - Madurai - Trivandrum --</p>          
          <div className="content-wrapper">    
            <Image src="/assets/img/group2.jpg" style={{ width: '50%', display: 'block', margin: '0 auto' }} fluid />
          </div>
          <p>Successful group tour 135 pax - Thanks to our Agents From Maharashtra, Red Sparrow Bus, Sealord Hotels, Bluhaze resort, Woodland Prime castle, Pagoda Resort</p>          
          <div className="content-wrapper">    
            <Image src="/assets/img/group3.jpg" style={{ width: '50%', display: 'block', margin: '0 auto' }} fluid />
          </div>
          <p>Successful Kerala Trip - Thanks for our Agent, Hotels and our pilots</p>          
          <div className="content-wrapper">    
            <Image src="/assets/img/group4.jpg" style={{ width: '50%', display: 'block', margin: '0 auto' }} fluid />
          </div>
          <p>Temple tours started on 11 May - Trivandrum - Kanyakumari -Madurai- Rameswaram - trichi - Thanjavur - Tirupati - Thanks for our Agent From Mumbai</p>          
          <div className="content-wrapper">    
            <Image src="/assets/img/group5.jpg" style={{ width: '50%', display: 'block', margin: '0 auto' }} fluid />
          </div>
        </div>
      </div>
    );
  }
}